import request from '../request';
const baseUrl = process.env.NODE_ENV !== 'production'
    ? 'community' // 开发环境
    : 'community'; // 生产环境
// 【选项】获取问题类型
export function getQuestionTypeOptionApi() {
    return request.post(baseUrl + '/question/type/option');
}
// 【选项】获取问题类型
export function questionAddApi(params) {
    return request.post(baseUrl + '/question/add', params);
}
// 【问题反馈】关注的问题列表
export function followedQuestionListApi(role, type, page) {
    return request.post(baseUrl + '/followed/question/list', { role, class: type, page });
}
// 【问题反馈】搜索问题
export function questionSearchApi(typeId, source, keyWord, page) {
    return request.post(baseUrl + '/question/search', { typeId, source, keyWord, page });
}
// 【问题反馈】删除问题
export function questionDeleteApi(id) {
    return request.post(baseUrl + '/question/delete', { id });
}
// 【问题反馈】关注问题
export function followedQuestionApi(id) {
    return request.post(baseUrl + '/question/follow', { id });
}
export function evaluationOrderRequestApi(params) {
    return request.post(baseUrl + '/evaluation/order/request', params);
}
/*
* 【航次评估】搜索/获取用户或企业收藏/关注的航次评估列表
* role 收藏者身份 1个人,2 企业
*/
export function followedEvaluationRequestListApi(role, type, page, filter) {
    return request.post(baseUrl + '/followed/evaluation/order/request/list', { role, class: type, page, filter });
}
/*
* 【航次评估】搜索/获取平台上的航次评估列表
*/
export function evaluationRequestListApi(page, filter) {
    return request.post(baseUrl + '/evaluation/order/request/list', { page, filter });
}
// 【航次评估】删除收藏/关注的航次评估
export function evaluationOrderRequestTrashApi(id) {
    return request.post(baseUrl + '/followed/evaluation/order/request/trash', { id });
}
// 【航次评估】恢复收藏/关注的航次评估
export function evaluationOrderRequestRecoverApi(id) {
    return request.post(baseUrl + '/followed/evaluation/order/request/recover', { id });
}
// 【航次评估】彻底删除收藏/关注的航次评估
export function evaluationOrderRequestDeleteApi(id) {
    return request.post(baseUrl + '/followed/evaluation/order/request/delete', { id });
}
// 【航次评估】获取航次评估请求信息
export function evaluationOrderRequestInfoApi(requestId) {
    return request.post(baseUrl + '/evaluation/order/request/info', { requestId });
}
// 【航次评估】进行航次评估
export function evaluationOrderAddApi(params) {
    return request.post(baseUrl + '/evaluation/order/add', { ...params });
}
// 【航次评估】获取航次评估回复
export function evaluationOrderListApi(id, page) {
    return request.post(baseUrl + '/evaluation/order/list', { id, page });
}
// 【航次评估】获取航次评估回复
export function evaluationOrderSupportApi(id) {
    return request.post(baseUrl + '/evaluation/order/support', { id });
}
// 【航次评估】收藏/关注航次评估
export function evaluationOrderRequestFollowApi(id) {
    return request.post(baseUrl + '/evaluation/order/request/follow', { id });
}
// 【航次评估】获取简约的航次评估回复
export function evaluationOrderLatestApi(id, page) {
    return request.post(baseUrl + '/evaluation/order/list/latest', { id, page });
}
// 【交流痕迹】添加交流痕迹/留言
export function noteAddApi(params) {
    return request.post(baseUrl + '/note/add', params);
}
// 【交流痕迹】编辑/更改交流痕迹/留言
export function noteEditApi(params) {
    return request.post(baseUrl + '/note/edit', params);
}
// 【交流痕迹】获取指定对象在当前企业下的交流痕迹
export function noteObjLogApi(objectType, objectId) {
    return request.post(baseUrl + '/note/obj/log', { objectType, objectId });
}
// 【交流痕迹】删除交流痕迹/留言
export function noteTrashApi(noteId) {
    return request.post(baseUrl + '/note/trash', { noteId });
}
// 【交流痕迹】获取当前企业在指定日期的留言统计
export function noteStatisticsApi(noteDate) {
    return request.post(baseUrl + '/note/statistics', { noteDate });
}
// 【交流痕迹】获取某用户在指定日期下的某类型的交流痕迹
export function noteUserLogApi(noterId, noteDate, objectType) {
    return request.post(baseUrl + '/note/user/log', { noterId, noteDate, objectType });
}
